module.exports = __webpack_public_path__ + "img/Seat.c65732f8.svg";